export default __webpack_public_path__ + "static/media/z.8817685e.svg";